import React, { useEffect, useState } from 'react';
import ProductCard from '../components/ProductCard';
import Loader from '../components/Loader';
import { useNavigate } from 'react-router-dom';
import { Pagination, Stack } from '@mui/material';
import useProductListing from '../hooks/useProductListing';

function AllProducts({ isAuthenticated, onAddToCart }) {
  const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  const [selectedChar, setSelectedChar] = useState('');
  const [sort, setSort] = useState('');

  const navigate = useNavigate();

  // Two modes, handled inside the hook (see its header):
  //
  //   no letter picked -> one server request for this page only
  //   letter picked    -> full catalogue from the IndexedDB cache, filtered
  //                       locally, because the Store API has no prefix filter
  //
  // Previously this page always took the second path, so the default view
  // downloaded all 2,279 products to render 30.
  const {
    products,
    loading,
    error,
    currentPage,
    totalPages,
    setPage,
  } = useProductListing({ perPage: 30, namePrefix: selectedChar, sort });

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user_data')) || {};
    if (userData.isSuperAdmin) navigate('/dashboard');
  }, [navigate]);

  if (loading) return <Loader />;

  return (
    <div className="content-wrapper">

      {/* HEADER */}
      <section className="product-pagination">
        <div className="container">
          <h2 style={{ textAlign: 'center', margin: '30px 0' }}>
            {selectedChar ? `Medicines Starting with - ${selectedChar}` : 'All Medicines'}
          </h2>

          {/* ALPHABET FILTER — clicking the active letter clears it, which the
              previous version offered no way to do short of reloading. */}
          <div className="pagination-alphabets d-grid">
            {alphabets.map((char) => (
              <div
                key={char}
                className={char === selectedChar ? 'active-product' : ''}
                onClick={() => setSelectedChar(char === selectedChar ? '' : char)}
              >
                <h3>{char}</h3>
              </div>
            ))}
          </div>

          {/* SORT */}
          <div className="product-filter">
            <label>Sort By:</label>
            <select value={sort} onChange={(e) => setSort(e.target.value)}>
              <option value="">Relevance</option>
              <option value="lowToHigh">Price: Low to High</option>
              <option value="highToLow">Price: High to Low</option>
            </select>
          </div>
        </div>
      </section>

      {/* PRODUCTS */}
      <section className="char-products-section">
        <div className="small-container d-grid">
          {products.length > 0 ? (
            products.map(item => (
              <ProductCard
                key={item.id}
                product={item}
                isAuthenticated={isAuthenticated}
                onAddToCart={onAddToCart}
              />
            ))
          ) : (
            <p>{error || 'No products found'}</p>
          )}
        </div>

        {totalPages > 1 && (
          <Stack spacing={2} sx={{ mt: 5, alignItems: 'center' }}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(event, value) => setPage(value)}
              color="primary"
            />
          </Stack>
        )}
      </section>

    </div>
  );
}

export default AllProducts;
